
import React from 'react';
import { useEffect, useState } from "react";
import { useWS } from '../provider/WS';
import { IMETAMessageType } from '../config/imetahuman';
import { useNavigate, useLocation } from 'react-router-dom';
import { MetaHumanComponent, useMetaHuman } from './MetaHumanComponent';
import { useSpeechToText } from './SpeechToTextComponent';
import { Card, Flex, Button, Select, Segmented, Popover, notification, List, Table, ConfigProvider } from 'antd';
import { TinyColor } from '@ctrl/tinycolor';
import { IDisplayMode } from "../config/displayMode";
import { IFields, IFieldsPos } from "../config/iFieldsLabels";
import some from 'lodash/some';
import { useMessageQueue } from "../provider/MessageQueue";
import { selectInput } from 'aws-amplify';
import SkeletonInput from 'antd/es/skeleton/Input';


const { v4: uuidv4 } = require('uuid');
const API_KEY = "018f0b97-409a-7a3a-a7c2-c2ed98e0013b"
let timer = null;

export const UI = ({ hidden, ...props }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [api, contextHolder] = notification.useNotification();
    const { message, lastJsonMessage } = useWS();
    const { actor, background, initialize, isTalking, isInitialized, toUE, addResponseEventListener, addStreamingDataListeners, smallVideoBox } = useMetaHuman();
    const { startCaptioning, startStopListening, blockListening, translation } = useSpeechToText();
    const [displayPushToTalk, setDisplayPushToTalk] = useState(false);
    const [displayMode, setDisplayMode] = useState(IDisplayMode.Full);
    const [tableDataSource, setTableDataSource] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [displayInfoCard, setDisplayInfoCard] = useState(false);
    const [clientUID, setClientUID] = useState('');
    const [stopQueue, setStopQueue] = useState(false);

    const { addMessage, consumeMessage, size, messages, newMessage } = useMessageQueue();



    const [config, setConfig] = useState({
        name: '',
        pixelstreamingUrl: '',
        backgroundImageUrl: '',
        actor: '',
        user: null,
        attributes: null,
        tenants: 'horizon',
        groups: '',
        options: '',
        isDisabled: false,
        micIsDisabled: false,
        pushToTalk: false,
        hideSpeechToTextInfo: false,
        hideStreamingInfo: false,
        actorName: '',
        clientType: 'HORIZON',
    });

    const [loaded, setLoaded] = useState(false);


    const sleep = (ms) => {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }


    const initMetaHuman = () => {
        if (config.user != null) {
            initialize(config);
            setLoaded(true);

        }
    }

    const processQueue = () => {

        if (stopQueue === true) {
            clearTimeout(timer);
            timer = setTimeout(processQueue, 1000);
            console.log(".");
        } else {
            if (size() > 0) {
                let m = consumeMessage();
                processMessage(m);
                setStopQueue(true);
                processQueue();
            } else {
                clearTimeout(timer);
            }
        }
    }



    useEffect(() => {

        /********************************************
         *  change layout
         ********************************************/
        console.log("DISPLAY MODE:", displayMode);
        if (displayMode == IDisplayMode.Full) {
            smallVideoBox(false);
            setDisplayInfoCard(false);

        }

        if (displayMode == IDisplayMode.Table) {
            smallVideoBox(true);
            setDisplayInfoCard(true);

        }


    }, [displayMode]);


    useEffect(() => {

        const script = document.createElement('script');
        script.src = '/webRtcPlayer.js'; // Assicurati di specificare il percorso corretto
        script.async = true;
        document.head.appendChild(script);

        if (location.state == null || API_KEY !== location.state.key) {
            navigate("/error")
        }


    }, []);

    useEffect(() => {
        if (isInitialized === true) {
            console.log("INITIALIZE META HUMAN");
            actor(2);
            background("https://metahuman.interlogica.ai/static/media/horizon.png");
            smallVideoBox(false);
        }

    }, [isInitialized]);

    useEffect(() => {

        console.log('Nuovo messaggio ricevuto:', lastJsonMessage);
        if (lastJsonMessage != null) {

            if (lastJsonMessage.type === 'cfg') {
                setConfig(prevConfig => ({ ...prevConfig, user: lastJsonMessage.id, pushToTalk: true, micIsDisabled: true, tenant: 'horizon', pixelstreamingUrl: "wss://ws.metahuman.interlogica.ai", clientType: "HORIZON" }));
                setDisplayPushToTalk(true);
                setClientUID(lastJsonMessage.id);
                message({
                    type: IMETAMessageType.CFGInfoUpdate,
                    model: 'horizon',
                    message: 'PING',
                    uid: uuidv4(),
                    user: lastJsonMessage.id,
                    clientID: lastJsonMessage.id,
                    clientType: "HORIZON"
                });

            }

            if (lastJsonMessage.type === IMETAMessageType.FROMADMINCommand) {
                if ("subType" in lastJsonMessage) {

                    /*
                    SetActor: 5,
                    SetBackground: 6,
                    RestartMH: 7
                    */

                    if (lastJsonMessage.subType === 5) actor(lastJsonMessage.data);
                    if (lastJsonMessage.subType === 6) background(lastJsonMessage.data);
                    if (lastJsonMessage.subType === 7) window.location.href = lastJsonMessage.data;
                }
            }


            if (lastJsonMessage.type === IMETAMessageType.UESpeak) {
                if ("other" in lastJsonMessage) {
                    addMessage(lastJsonMessage.message, lastJsonMessage.other, lastJsonMessage.animation);
                } else {
                    addMessage(lastJsonMessage.message, "", lastJsonMessage.animation);
                }

                processQueue();
            }


        }




    }, [lastJsonMessage]);

    const processMessage = (lastJsonMessage) => {


        let message = { type: IMETAMessageType.UESpeak, message: lastJsonMessage.message, animation: lastJsonMessage.animation };



        if ("other" in lastJsonMessage) {
            if (Array.isArray(lastJsonMessage.other)) {
                setDisplayMode(IDisplayMode.Table);
                let i = 0;
                let columns = [];
                let dataSource = [];
                lastJsonMessage.other.forEach(element => {
                    console.log(element);
                    if (i === 0) {
                        Object.keys(element).forEach(key => {

                            columns.push({
                                title: IFields[key],
                                dataIndex: key,
                                key: IFieldsPos[key],
                                render: (value) => {

                                    if (typeof value === "number") {
                                        const chatWorlds = ['deposit', 'rental_amount'];

                                        const containsElement = some(chatWorlds, element => key.includes(element));

                                        if (containsElement) {
                                            return value.toLocaleString("it-IT") + "€";
                                        } else {
                                            return value.toLocaleString("it-IT");
                                        }
                                    } else {
                                        if (value != null && value.startsWith("http")) {
                                            return <img src={`${value}`} style={{ width: "120px" }} onError={event => {
                                                event.target.src = "https://pictures.dealer.com/g/ganleychevroletofauroraoh/0430/a976281f56ff06d46dc390283aa14da6x.jpg"
                                                event.onerror = null
                                            }} />;
                                        } else {
                                            if (value != null) {
                                                return value.charAt(0).toUpperCase() + value.slice(1);
                                            } else {
                                                return value;
                                            }
                                        }
                                    }


                                }
                            });

                        })

                        columns.sort((firstItem, secondItem) => firstItem.key - secondItem.key);

                        setTableColumns(columns);
                    }

                    element.key = i;
                    dataSource.push(element);

                    i++;
                });
                setTableDataSource(dataSource);
            }

            

        }
        enableDisableMicrophone(false);
        toUE(message);
        setStopQueue(true);

    }


    /*******************************
     *  TextToSpeech to AI Backend
     *******************************/

    useEffect(() => {


        let check = checkIfSendMessageToBackEnd(translation)
        console.log("CHECK IF SEND SPEECH MESSAGE", check);
        if (check === true) {

            setDisplayMode(IDisplayMode.Full);
            openNotification(translation);


            message({
                type: IMETAMessageType.AIRequest,
                model: config.tenant,
                message: translation,
                uid: uuidv4(),
                user: config.user
            });


        }

    }, [translation]);




    const enableDisableMicrophone = (status) => {



        if (status == true) {
            startCaptioning();
        } else {

            blockListening();
        }

    }

    const openNotification = (message) => {
        let placement = 'bottomRight';
        api.info({
            message: `Speech detected`,
            description:
                message,
            placement,
        });
    };


    const checkIfSendMessageToBackEnd = (translation) => {

        let response = false;

        if (translation != '' && translation != undefined) {
            response = true;

        } else {
            response = false;
        }


        console.log('CHECK MESSAGE FUNCTION', response);
        return response;
    }



    addResponseEventListener("handle_responses", function (data) {
        console.log("DATAAAAAAAAAA", data);
        try {
            let jp = JSON.parse(data);
            if (jp.hasOwnProperty('type') && jp.type === IMETAMessageType.UEStopSpeak) {
                setStopQueue(false)
                processQueue();
            }
        } catch (e) {

        }
    });

    const colors0 = ['#6253E1', '#04BEFE'];
    const colors1 = ['#40e495', '#30dd8a', '#2bb673'];
    const getHoverColors = (colors) =>
        colors.map((color) => new TinyColor(color).lighten(5).toString());
    const getActiveColors = (colors) =>
        colors.map((color) => new TinyColor(color).darken(5).toString());

    return (
        <>
            <div hidden={!loaded}>
                <img className='Logo' src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
                <MetaHumanComponent />
                <div className='micPushButton' hidden={!displayPushToTalk}>
                    <Card className='micPushButtonCard'
                        bordered={false}
                        style={{ height: "150px", width: "150px" }}
                        onMouseDown={() => enableDisableMicrophone(true)}
                        onMouseUp={() => enableDisableMicrophone(false)}
                        onTouchStart={() => enableDisableMicrophone(true)}
                        onTouchEnd={() => enableDisableMicrophone(false)}
                    >
                        Push To Talk
                    </Card>
                </div>

                <div className='uidinfo'>{clientUID}</div>
                <Flex vertical className='tableflexBackground' justify='center' align='center'>

                    <Flex vertical className='tableflexCardInside' justify='center' align='center' style={{ backgroundImage: `url(${config.backgroundImageUrl})` }}>
                        <Card className='tableflexCard' hidden={!displayInfoCard}
                            bordered={false}
                            style={{ height: "100vh" }}
                        >
                            <Table dataSource={tableDataSource} columns={tableColumns} pagination={false} />
                        </Card>
                    </Flex>
                </Flex>



            </div>



            <div hidden={loaded}>
                <Flex className='Main' justify='center' align='center'>
                    <Card className='Login'
                        bordered={false}
                        style={{ width: 400 }}
                    >

                        <Flex justify='center' align='center'>
                            Press "Start" to load Metahuman
                            <br></br>
                            <br></br>
                        </Flex>
                        <Flex justify='center' align='center'>

                            <ConfigProvider
                                theme={{
                                    components: {
                                        Button: {
                                            colorPrimary: `linear-gradient(135deg, ${colors1.join(', ')})`,
                                            colorPrimaryHover: `linear-gradient(135deg, ${getHoverColors(colors1).join(', ')})`,
                                            colorPrimaryActive: `linear-gradient(135deg, ${getActiveColors(colors1).join(', ')})`,
                                            lineWidth: 0,
                                        },
                                    },
                                }}
                            >
                                <Button type="primary" onClick={initMetaHuman} size="large">
                                    Start
                                </Button>
                            </ConfigProvider>
                        </Flex>
                    </Card>
                </Flex>
            </div>
            {contextHolder}
        </>
    );
};